import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import { Providers } from '../../enums/providers';

export const CarrierSharingService = {
  combineSharedServices: (availableServices, storeGuid, sharedByPartnerServices) => {
    if (sharedByPartnerServices === emptyObject || sharedByPartnerServices === emptyArray) {
      return availableServices;
    }

    const groups = [];
    sharedByPartnerServices
      .filter((s) => s.storeGuid === storeGuid || storeGuid === undefined)
      .forEach((serviceConfiguration) => {
        serviceConfiguration.serviceGroups.forEach((group) => {
          const selectedGroup = {
            groupId: group.groupId,
            name: `Client ${group.name}`,
            items: [],
          };

          const findGroup = groups.find((o) => o.groupId === selectedGroup.groupId);
          if (!findGroup) {
            selectedGroup.items = group.items;
            groups.push(selectedGroup);
          } else {
            group.items.forEach((item) => {
              if (!findGroup.items.find((i) => i.serviceId === item.serviceId)) {
                findGroup.items.push(item);
              }
            });
          }
        });
      });

    if (groups.length > 0) {
      const oldCarrierSharingSupportedGroups = [
        Providers.ClientStamps.labelProviderId,
        Providers.ClientFedex.labelProviderId,
        Providers.ClientUPS.labelProviderId,
        Providers.ClientDhlExpress.labelProviderId,
        Providers.ClientSharedCarriers.labelProviderId,
      ];
      // it filters out old carrier sharing integrations "Client ..." services from services dropdown
      // and
      // it filters out "Client Shared Carriers" services from services dropdown to avoid duplicates
      const filtered = availableServices
        .filter((service) => !oldCarrierSharingSupportedGroups.includes(service.groupId))
        .filter((service) => typeof service.name !== 'string' || (typeof service.name === 'string' && !service.name.startsWith('Client')));
      return groups.concat(filtered);
    }

    return availableServices;
  },

  selectedServiceName: (serviceId, serviceName, sharedByPartnerServices, sellerLabelProviderId) => {
    if (sharedByPartnerServices === emptyObject || sharedByPartnerServices === emptyArray) {
      return serviceName;
    }

    let partnerServiceName = serviceName;
    sharedByPartnerServices.forEach((group) => {
      group.items.forEach((item) => {
        if (item.serviceId === serviceId && item.sellerLabelProviderId === sellerLabelProviderId) {
          partnerServiceName = item.name;
        }
      });
    });

    return partnerServiceName;
  },

  selectedServiceNameByStore: (serviceId, serviceName, sharedByPartnerServices) => {
    if (sharedByPartnerServices === emptyObject || sharedByPartnerServices === emptyArray) {
      return serviceName;
    }

    let partnerServiceName = serviceName;
    sharedByPartnerServices.forEach((serviceConfiguration) => {
      serviceConfiguration.serviceGroups.forEach((group) => {
        group.items.forEach((item) => {
          if (item.serviceId === serviceId) {
            partnerServiceName = item.name;
          }
        });
      });
    });

    return partnerServiceName;
  },
};
